import { always, prop, propEq, applySpec } from 'ramda'

const MOSAIC_OPT_IN_ACTION_TYPE = 'MOSAIC_OPT_IN'
const MOSAIC_OPT_IN_DISPLAY_TYPE = 'Add to mosaic'

const isMosaicOptInFormAction = propEq('type', MOSAIC_OPT_IN_DISPLAY_TYPE)

const convertMosaicOptInFormActionToWidgetAction = applySpec({
  type: always(MOSAIC_OPT_IN_ACTION_TYPE),
  actions: [
    {
      type: always('SEND_DARK_TWEET'),
      message: prop('message'),
      attachmentUrl: prop('attachmentUrl'),
      cardUri: prop('cardUri'),
      media: prop('media')
    }
  ]
})

export { isMosaicOptInFormAction, convertMosaicOptInFormActionToWidgetAction }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/form-to-widget/mosaic-opt-in.js